<template>
  <div id="neuronal-health-text" :class="classes">
    <!-- <transition name="fade"> -->
      <span v-if="$store.state.showDetailedInfo">
        <p v-for="copy in copyData[year].copy" :key="copy" v-html="copy"></p>
      </span>
    <!-- </transition> -->
  </div>
</template>
<script>
import progressionMixin from "@/mixins/progressionMixin";

export default {
  name: "NeuronalHealthText",
  mixins: [progressionMixin],
  computed: {
    year() {
      return this.$store.state.year;
    }
  },
  data() {
    return {
      copyData: {
        0: {
          copy: [
            "At the neuronal level, we will examine how changes in neuroinflammation and neurodegeneration correlate with measurable&nbsp;disease&nbsp;outcomes."
          ]
        },
        1: {
          copy: [
            "MS neuropathology is triggered when autoreactive B cells and T cells cross the blood-brain barrier to enter the central nervous system (CNS). Inside the CNS, these cells cause damage to the myelin sheath and oligodendrocytes. This damage appears as lesions on&nbsp;MRI&nbsp;scans.<sup>5,10</sup>"
          ]
        },
        2: {
          copy: [
            "Myelin is generated by glial cells called oligodendrocytes in the central nervous system (CNS). The myelin sheath provides a layer of insulation, which improves axonal function by increasing the energy efficiency and conduction velocity of action potentials, which are the primary method of communication between neurons in the CNS.<sup>16</sup>"
          ]
        },
        3: {
          copy: [
            "Diffuse cerebral axonal damage develops rapidly at the earliest stages of disease, and correlates more strongly with disability as assessed by the EDSS in patients with milder forms&nbsp;of&nbsp;MS.<sup>20</sup>"
          ]
        },
        4: {
          copy: [
            "Immune-modulatory networks are triggered to limit inflammation and to initiate repair, which results in at least partial remyelination; this neuronal activity correlates with periods of clinical remission&nbsp;in&nbsp;RRMS.<sup>24</sup>"
          ]
        },
        5: {
          copy: [
            "Size and quantity of lesions within the first five years of diagnosis are correlated with disease severity at 20 years.  Greater evidence of inflammatory activity is associated with greater disability at&nbsp;20&nbsp;years.<sup>22</sup>"
          ]
        },
        6: {
          copy: [
            "Although the early stage of MS is characterized by neuroinflammation, some degree of neurodegeneration is likely present from disease onset, often subclinically in the early stages. The rate of neurodegeneration may depend on differences in the degree and activation of&nbsp;inflammatory&nbsp;activity.<sup>30</sup>"
          ]
        },
        7: {
          copy: [
            "Functional status, as measured by EDSS, negatively correlates with brain function, as assessed using N&#8209;acetylaspartate : creatinine resonance intensity ratios (NAA:Cr),&nbsp;in&nbsp;RRMS.<sup>34</sup>"
          ]
        },
        8: {
          copy: [
            "Chronically demyelinated axolemma, the cell membrane of an axon, eventually lose critical molecules that are essential for neuronal communication. The loss of these molecules may be a key contributor to neurological decline in&nbsp;chronic&nbsp;MS.<sup>37</sup>"
          ]
        },
        9: {
          copy: [
            "Mechanisms hypothesized to lead to neurodegeneration in MS include inflammation, mitochondrial dysfunction, chronic axonal demyelination, and lesion formation through antegrade/retrograde&nbsp;degeneration.<sup>5</sup>"
          ]
        },
        10: {
          copy: [
            "In early RRMS, autoreactive T cells and B cells drive neuropathology associated with relapses. As disease transitions to SPMS, the drivers of axonal loss include microglia, astrocytes, and&nbsp;B-cell&nbsp;activity.<sup>24</sup>"
          ]
        },
        11: {
          copy: [
            "SPMS is characterized by brain atrophy and neurodegeneration resulting from axonal loss, cortical demyelination, microglia activation, and failure&nbsp;of&nbsp;remyelination.<sup>24</sup>"
          ]
        },
        12: {
          copy: [
            "Autoreactive T cells play a central role in axonal damage and dissection in late-stage&nbsp;MS.<sup>24</sup>"
          ]
        },
        13: {
          copy: [
            "The mechanisms underlying alterations of axonal transport regulation are not well understood, so it is currently not possible to repair&nbsp;axonal&nbsp;damage.<sup>30</sup>"
          ]
        },
        14: {
          copy: [
            "Brain function, as assessed using N-acetylaspartate : creatinine resonance intensity ratios (NAA:Cr), also declines over time, and is significantly lower in SPMS&nbsp;compared to&nbsp;RRMS.<sup>20</sup>"
          ]
        },
        15: {
          copy: [
            "There is a strong correlation between brain function, as assessed using N-acetylaspartate : creatinine resonance intensity ratios (NAA:Cr), and disease duration in MS, suggesting that axonal damage is a critical factor of physical disability throughout the course&nbsp;of&nbsp;disease.<sup>20</sup>"
          ]
        },
        16: {
          copy: [
            "Atrophy of neuronal soma, or the cell body, is another hallmark of neuropathology&nbsp;in&nbsp;MS.<sup>2</sup>"
          ]
        },
        17: {
          copy: [
            "Damage to gray matter, which is composed primarily of cell bodies, is also a critical factor underlying disease progression and permanent disability in MS patients. This damage correlates with decreased brain volume and increasing scores on&nbsp;the&nbsp;EDSS.<sup>16</sup>"
          ]
        },
        18: {
          copy: [
            "Complete demyelination can result in conduction blocks and axonal degeneration due to the accumulation of intracellular calcium, which&nbsp;is&nbsp;excitotoxic.<sup>16</sup>"
          ]
        },
        19: {
          copy: [
            "Neuronal health is a critical factor to monitor and preserve in order to slow progression and maximize long-term prognosis. The more active these pathological neurological processes are at baseline, the faster patients progress&nbsp;to&nbsp;SPMS.<sup>22</sup>"
          ]
        },
        20: {
          copy: [
            "Anti-inflammation, neuroprotection, and myelin repair represent the best strategies for disease management; however, early treatment is still recommended as the best strategy to slow disease progression in&nbsp;progressive&nbsp;MS.<sup>30</sup>"
          ]
        }
      }
    };
  }
};
</script>
<style lang="scss">
#neuronal-health-text {
  position: absolute;
  top: 50px;
  right: 10px;
  width: 200px;

  &.subtitle {
    position: relative;
    top: 0;
    right: auto;
    width: 80%;
  }
}
</style>
